export function initializeMasteryScore(masteryScore ){
    if( masteryScore && !isNaN(masteryScore) ) {
        return masteryScore;
    }
    return 80;
}
